import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { DropdownItem, Input } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { RootStoreContext } from "../../app/stores/rootStore";

const MainNavBarAutoSyncCheckbox = () => {
  const rootStore = useContext(RootStoreContext);
  const { isAutoSyncEnabled, setAutoSync } = rootStore.commonStore;
  const { enableSync } = rootStore.tenantStore;
  const [t] = useTranslation(["translation"], translationHookOptions);

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAutoSync(e.target.checked);
    enableSync();
  }
  
  return (
    <>
      <DropdownItem>
        <div className="custom-control custom-checkbox">
          <Input
            type="checkbox"
            id="cb_autosync"
            className="custom-control-input"
            checked={isAutoSyncEnabled}
            onChange={handleCheckboxChange}
          />
          <label
            className="custom-control-label text-nowrap"
            htmlFor="cb_autosync"
            style={{fontSize:"14px"}}
          >
            {t("navbar_dropdown_autosync")}
          </label>
        </div>
      </DropdownItem>
      <DropdownItem divider />
    </>
  );
};

export default observer(MainNavBarAutoSyncCheckbox);
